import { useUnit } from 'effector-react';
import {
  $userLoginHistory,
  $userLoginTableProps,
  changeUserLoginTableEv,
  getAdminLoginHistoryFx,
  getUserLoginHistoryFx,
  UserLoginHistoryGate,
} from '../../models/adminSecurityModel/index.js';
import Table from 'antd/es/table';
import dayjs from 'dayjs';
import { Button, Input, message } from 'antd';
import { useState } from 'react';

export default function UserLoginHistory({ admin }) {
  const { data, count } = useUnit($userLoginHistory);
  const adminLoading = useUnit(getAdminLoginHistoryFx.pending);
  const userLoading = useUnit(getUserLoginHistoryFx.pending);
  const loading = adminLoading || userLoading;
  const [search, setSearch] = useState(null);

  const table = useUnit($userLoginTableProps);
  const changeTable = useUnit(changeUserLoginTableEv);

  const columns = [
    { dataIndex: 'id', title: 'ID' },
    { dataIndex: 'user_id', title: 'ID пользователя', hidden: !admin },
    { dataIndex: 'object_name', title: 'Имя пользователя', hidden: !admin },
    { dataIndex: 'ip_address', title: 'IP-адрес' },
    { dataIndex: 'action', title: 'Результат' },
    {
      dataIndex: 'event_datetime',
      title: 'Дата и время',
      render: (d) => dayjs(d).format('YYYY-MM-DD HH:mm:ss'),
    },
  ];

  return (
    <>
      <UserLoginHistoryGate />
      {admin && (
        <div
          style={{ display: 'flex', gap: 16, width: '40%', marginBottom: 16 }}
        >
          <Input
            onChange={(e) => setSearch(e.target.value)}
            value={search}
            placeholder={'Поиск по ID пользователя'}
          />
          <Button
            onClick={() => {
              if (search && Number.isFinite(+search)) {
                changeTable({
                  user_id: Number.isFinite(+search) ? +search : null,
                });
              } else {
                message.warning('Введите числовое значение').then(() => null);
              }
            }}
          >
            Поиск
          </Button>
          <Button
            danger
            onClick={() => {
              setSearch(null);
              changeTable({ user_id: null });
            }}
          >
            Сбросить
          </Button>
        </div>
      )}
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          onChange: (curPage, pageSize) => {
            changeTable({
              page: curPage,
              limit: pageSize,
            });
          },
          total: count,
          current: table.page,
          pageSize: table.limit,
        }}
      />
    </>
  );
}
